import React, { FC } from 'react';
import { ButtonBase, ButtonBaseProps, Link } from '@mui/material';
import { Colors } from '../../../constants';
import { clsx } from '../../../utils';

interface CoreLinkButtonProps extends ButtonBaseProps {
	to?: string;
}

export const CoreLinkButton: FC<CoreLinkButtonProps> = (props) => {
	const { to, sx, ...buttonProps } = props;

	const Component = to ? Link : buttonProps.component ?? 'button';

	return (
		<ButtonBase
			{...buttonProps}
			component={Component}
			href={to}
			sx={clsx(
				{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-start',
					gap: '6px',

					textTransform: 'none',
					maxWidth: 'fit-content',
					borderRadius: '100px',
					border: 'none',
					py: '8px',
					px: '12px',
					color: Colors.white,
					fontSize: '14px',
					fontWeight: '500',
					fontFamily: 'Montserrat, sans-serif',
					backgroundColor: Colors.white_a10,

					'&:hover': {
						backgroundColor: Colors.white_a20,
					},

					'&.Mui-disabled': {
						color: Colors.grayDark,
					},
				},
				sx
			)}
		/>
	);
};
